import { fromTable } from '@/integrations/supabase/db';
import { SearchResult, SearchSectionId } from '../types';
import { getMatchFunction, getServerPattern, getServerLimit, calculateRelevanceScore } from '../utils';

export async function searchKunden(
  term: string, 
  limit: number, 
  exactMatch: boolean,
  fuzzyMatch: boolean = false,
  signal?: AbortSignal
): Promise<SearchResult[]> {
  if (!term.trim()) return [];
  
  const pattern = getServerPattern(term, fuzzyMatch);
  const serverLimit = getServerLimit(limit, fuzzyMatch);
  const matchFn = getMatchFunction(exactMatch, fuzzyMatch);
  
  const { data, error } = await fromTable('kunden')
    .select('id, vorname, zuname, firmenname, email, telefonnummer, ort, kundentyp, updated_at')
    .or(`vorname.ilike.${pattern},zuname.ilike.${pattern},firmenname.ilike.${pattern},email.ilike.${pattern}`)
    .limit(serverLimit);

  if (error) {
    console.error('Kunden search error:', error);
    return [];
  }

  return (data || [])
    .filter(k => matchFn(term, k.vorname, k.zuname, k.firmenname, k.email, k.telefonnummer, k.ort))
    .slice(0, limit)
    .map(k => {
      const title = k.firmenname || `${k.vorname || ''} ${k.zuname || ''}`.trim() || 'Unbenannt';
      const subtitle = [k.email, k.ort].filter(Boolean).join(' • ');
      
      return {
        id: k.id,
        type: 'kunden' as SearchSectionId,
        title,
        subtitle,
        badge: k.kundentyp === 'gewerbe' ? 'Gewerbe' : 'Privat',
        data: k,
        relevanceScore: calculateRelevanceScore(term, title, subtitle, k.updated_at)
      };
    });
}
